import _ from 'lodash';
import { FAQ_SEARCH } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * UrgentNotification Reducer
 * @param {*} state
 * @param {*} action
 */
export default function faqSearch(state = initialState, action = {}) {
  switch (action.type) {
    case `${FAQ_SEARCH}_PENDING`:
      return {
        ...state,
        error: null, // state.error = null
        loaded: false, // state.loaded = false
        loading: true, // state.loading = true
      };
    case `${FAQ_SEARCH}_SUCCESS`:
      let faqSearch;
      if (action.bStart === 0) {
        faqSearch = action?.result?.data?.attributes?.items;
      } else {
        faqSearch = _.concat(
          state.faqSearch ?? [],
          action?.result?.data?.attributes?.items,
        );
      }
      return {
        ...state,
        error: null,
        result: action?.result,
        faqSearch: faqSearch,
        loaded: true,
        loading: false,
      };
    case `${FAQ_SEARCH}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
